import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b041d95c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-form" }
const _hoisted_2 = { class: "select-row" }
const _hoisted_3 = {
  key: 0,
  class: "select-label"
}

import { computed, ref } from 'vue';
import WidgetSearch from '@/components/business/crud/form/WidgetSearch.vue';
import WidgetTableBody from '@/components/business/crud/table/WidgetTableBody.vue';
import WidgetTableButton from '@/components/business/crud/table/WidgetTableButton.vue';
import WidgetTablePagination from '@/components/business/crud/table/WidgetTablePagination.vue';
import { createSearchService } from '@/components/business/crud/service/CrudSearchService';
import { createCrudTableService } from '@/components/business/crud/service/CrudTableService';
import WidgetSearchBtn from '@/components/business/crud/form/WidgetSearchBtn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectModelTable',
  props: {
    moduleName: {},
    controllerName: {},
    labelName: {},
    condition: {},
    inputLabel: {},
    hiddenFields: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showSearch = ref(false);
const searchService = createSearchService(
  props.moduleName,
  props.controllerName
);
const { form, groups, getCondition } = searchService.use();

const service = createCrudTableService(props.moduleName, props.controllerName);
service.listConfig.pageSize = 10;
if (props.hiddenFields) {
  service.widgetContainer.hiddenFields(...props.hiddenFields);
}
const { schema, columns, listData, buttons } = service.use();

function onSearch() {
  if (props.condition) {
    service.listConfig.condition = {
      $and: [props.condition, getCondition()],
    };
  } else {
    service.listConfig.condition = getCondition();
  }
}

searchService.init().then(() => {
  onSearch();
  service.init();
  service.widgetContainer.hideButtonsExclude('view', 'refresh');
});

/**
 * 计算新的modelValue值
 * @param modelValue 当前的modelValue值，既历史已选择的值
 * @param currentPageData 当前页面的数据
 * @param currentPageSelectedData 当前页面已选择的数据
 */
function computeNewModelValue(
  modelValue: any[],
  currentPageData: any[],
  currentPageSelectedData: any[]
): any[] {
  // 创建当前页面ID集合
  const currentPageSet = new Set(currentPageData.map(getDataKey));

  // 创建当前页面选中数据的Map
  const currentPageSelectedMap = new Map(
    currentPageSelectedData.map((item) => [getDataKey(item), item])
  );

  // 用于存储新的modelValue
  const newModelValue: any[] = [];
  // 遍历历史modelValue
  for (const item of modelValue) {

    if (!currentPageSet.has(getDataKey(item))) {
      // 不在当前页面的数据，直接保留
      newModelValue.push(item);
    } else if (currentPageSelectedMap.has(getDataKey(item))) {
      // 在当前页面且已选中的数据，保留并从currentPageSelectedMap移除
      newModelValue.push(item);
      currentPageSelectedMap.delete(getDataKey(item));
    }
  }
  // 将currentPageSelectedMap中剩余的选中数据添加到newModelValue
  newModelValue.push(...currentPageSelectedMap.values());
  return newModelValue;
}

function getDataKey(data: any) {
  return data[schema.primary];
}

const rowSelection = {
  fixed: true,
  selectedRowKeys: computed(() =>
    props.modelValue.map((i) => i[schema.primary])
  ),
  onChange: (_: any[], rows: any[]) => {
    emit(
      'update:modelValue',
      computeNewModelValue(props.modelValue, listData.list, rows)
    );
  },
};

const selected = computed({
  get: () =>
    props.modelValue.map((i) => {
      return {
        label: i[props.labelName],
        value: i[schema.primary],
      };
    }),
  set: (value) => {
    const selectedSet = new Set(value.map((i: any) => i.value));
    emit(
      'update:modelValue',
      props.modelValue.filter((i: any) => selectedSet.has(i[schema.primary]))
    );
  },
});

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.inputLabel === undefined || _ctx.inputLabel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.inputLabel || '已选择'), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_a_select, {
          value: selected.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
          open: false,
          options: selected.value,
          class: "select",
          "label-in-value": "",
          mode: "tags"
        }, null, 8, ["value", "options"])
      ])
    ]),
    _createVNode(WidgetSearch, {
      form: _unref(form),
      groups: _unref(groups),
      onSearch: onSearch,
      show: showSearch.value
    }, null, 8, ["form", "groups", "show"]),
    _createVNode(WidgetTableButton, { buttons: _unref(buttons) }, {
      default: _withCtx(() => [
        _createVNode(WidgetSearchBtn, {
          modelValue: showSearch.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showSearch).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["buttons"]),
    _createVNode(WidgetTableBody, {
      columns: _unref(columns),
      "list-data": _unref(listData),
      "select-row-key": _unref(schema).primary,
      "row-selection": rowSelection,
      selectable: ""
    }, null, 8, ["columns", "list-data", "select-row-key"]),
    _createVNode(WidgetTablePagination, {
      "page-size": _unref(service).listConfig.pageSize,
      "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(service).listConfig.pageSize) = $event)),
      "page-num": _unref(service).listConfig.pageNum,
      "onUpdate:pageNum": _cache[3] || (_cache[3] = ($event: any) => ((_unref(service).listConfig.pageNum) = $event)),
      count: _unref(listData).count
    }, null, 8, ["page-size", "page-num", "count"])
  ]))
}
}

})